
import { observable, action, runInAction } from 'mobx';
import { message } from 'antd';
import moment from 'moment';

class store {
    @observable data = {};

    getData = () => {
        fetch('/getTableSwitch', { credentials: 'include' }).then(x => x.json()).then(x => {
            runInAction(() => {
                this.data = x.data || {}
            });
        }).catch(err => {
            console.error(err);
        })
    }

    @action
    onClearData = () => {
        this.data = {};
    }
}

const revenue = new store();

export default revenue;


// WEBPACK FOOTER //
// ./src/store/tableSwitch.js